import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Vehicle } from 'src/app/shared/models/vehicle';
import { User } from 'src/app/shared/models/security/user';
import { VehiculeStatus } from 'src/app/shared/enums/vehicule-status-enum';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VehiculeModalAjoutComponent } from '../modal/vehicule-modal-ajout/vehicule-modal-ajout.component';
import { LogService } from 'src/app/core/services/log/log.service';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-vehicule',
	templateUrl: './list-vehicule.component.html',
	styleUrls: ['./list-vehicule.component.scss']
})
export class ListVehiculeComponent implements OnInit {
	vehicules: Vehicle[] = [];
	currentPage = 0;

	isAddable = false;
	isImportable = false;

	sortType = 'name';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	user: User = null;

	minTravelledDistance: number = null;
	maxTravelledDistance: number = null;
	minMileageCost: number = null;
	maxMileageCost: number = null;

	vehiculeStatus = VehiculeStatus;
	selectedStatus: string[] = [];

	ajoutModalref: BsModalRef;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.getVehicules();
		this.isAddable = true;
	}

	getVehicules() {
		this.facade.vehiculeService.getAllVehicule().subscribe({
			next: (vehicules: Vehicle[]) => {
				this.vehicules = vehicules;
			},
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			}
		});
	}

	selectVehicule(vehicule: Vehicle) {
		const link = ['/gestion/vehicules', vehicule.id];
		this.router.navigate(link);
	}

	openModalAjout() {
		const initialState = {};
		this.ajoutModalref = this.modalService.show(VehiculeModalAjoutComponent, {
			class: 'modal-lg',
			initialState
		});

		this.ajoutModalref.onHide.subscribe((reason: string | any) => {
			this.getVehicules();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	changeStatusFilter(values: any, status: string): void {
		//Add
		if (values.currentTarget.checked) {
			let clone = [...this.selectedStatus];
			clone.push(status);
			this.selectedStatus = clone;
		} else {
			//Remove
			this.selectedStatus = this.selectedStatus.filter((e) => e !== status);
		}
	}
}
